import React, {
	useState,
	useEffect,
	createContext,
	useContext,
	useCallback,
	useRef,
} from "react";
import { useNavigate } from "react-router-dom";
import { getAdminUser, setAuthErrorHandler } from "../api/apiServiceFetch";
import { stopAdminRealtime } from "../realtime/adminRealtimeClient";

const ADMIN_TOKEN_KEY = "jdAdminToken";
const ADMIN_REFRESH_TOKEN_KEY = "jdAdminRefreshToken";

function AuthProvider(props) {
	const navigate = useNavigate();
	const [userBase, setUserBase] = useState();
	const [loading, setLoading] = useState(true);
	const isHandlingAuthErrorRef = useRef(false);

	const signOut = useCallback(() => {
		setUserBase(null);
		localStorage.removeItem(ADMIN_REFRESH_TOKEN_KEY);
		localStorage.removeItem(ADMIN_TOKEN_KEY);
		localStorage.removeItem("refreshToken");
		localStorage.removeItem("token");
		void stopAdminRealtime();
		navigate("/login");
	}, [navigate]);

	useEffect(() => {
		setAuthErrorHandler((reason) => {
			if (isHandlingAuthErrorRef.current) return;
			isHandlingAuthErrorRef.current = true;

			console.warn("Auth session ended:", reason);
			setUserBase(null);
			localStorage.removeItem(ADMIN_REFRESH_TOKEN_KEY);
			localStorage.removeItem(ADMIN_TOKEN_KEY);
			localStorage.removeItem("refreshToken");
			localStorage.removeItem("token");
			void stopAdminRealtime();
			navigate("/login", { replace: true });

			setTimeout(() => {
				isHandlingAuthErrorRef.current = false;
			}, 1000);
		});

		return () => {
			setAuthErrorHandler(null);
		};
	}, [navigate]);

	useEffect(() => {
		(async function () {
			// Skip the session probe entirely when there's no token in storage —
			// otherwise the unauthenticated /login page generates a noisy 401 +
			// "missing refresh token" trail on every load.
			const hasToken =
				Boolean(localStorage.getItem(ADMIN_TOKEN_KEY)) ||
				Boolean(localStorage.getItem("token"));

			if (!hasToken) {
				setLoading(false);
				return;
			}

			try {
				const user = await getAdminUser();
				setUserBase(user);
			} catch (error) {
				if (!error?.isAuthError) {
					console.error("Failed to load user:", error);
					navigate("/login");
				}
			} finally {
				setLoading(false);
			}
		})();
	}, [navigate]);

	const refreshUser = useCallback(async (userId) => {}, []);

	const onClose = () => {};
	return (
		<AuthContext.Provider
			value={{ userBase, setUserBase, signOut, onClose, refreshUser, loading }}
			{...props}
		/>
	);
}

const AuthContext = createContext({ loading: false });
const useAuth = () => useContext(AuthContext);

export { AuthProvider, useAuth };
